import type { UsePartnersParams } from '~/store-v2/partners/usePartners'
import { useToast } from '@solfacil/girassol'
import usePartner from '~/store-v2/partners/usePartner'
import usePartners from '~/store-v2/partners/usePartners'

interface PartnerSelection {
  fantasyName: string
  partnerId: number
}

export default function usePartnerManager(updateSearchTerm: boolean = false) {
  const { createErrorToast } = useToast()
  const { t } = useI18n()
  const impersonateStore = useImpersonateStore()

  const partnerName = ref('')
  const partnerSelected = ref<PartnerSelection>()

  const partnerId = computed(() =>
    partnerSelected.value?.partnerId.toString() ?? '',
  )

  const params = ref<UsePartnersParams>({
    page: 0,
    search_term: '',
  })

  const {
    data: partners,
    isLoading: isLoadingPartners,
    isFetching: isFetchingPartners,
  } = usePartners(params)

  const { data: partnerData } = usePartner(partnerId)

  const allPartners = computed(() => partners?.value)

  const handleChangeValue = (value: string) => {
    if (updateSearchTerm) {
      params.value.search_term = value
    }
    else {
      partnerName.value = value
    }
  }

  const selectPartner = (partnerId: number, fantasyName: string) => {
    partnerSelected.value = { fantasyName, partnerId }
    partnerName.value = fantasyName
  }

  const handleImpersonate = () => {
    if (!partnerSelected.value) {
      impersonateStore.deleteImpersonate()
      impersonateStore.toggleImpersonateModal()
      createErrorToast({
        title: t('header.impersonate.error.title'),
        description: t('header.impersonate.error.description'),
      })
      return
    }

    const partner = {
      ...partnerSelected.value,
      solfacilPlus: {
        level: partnerData.value?.sfplus.level.toString() || '',
        isLevelBlack: partnerData.value?.sfplus.is_level_black || false,
      },
      registrationType: partnerData.value?.registration_type || '',
    }

    impersonateStore.createImpersonate(partner)
    impersonateStore.toggleImpersonateModal()
  }

  return {
    partnerName,
    partnerSelected,
    allPartners,
    isLoadingPartners,
    isFetchingPartners,
    handleChangeValue,
    selectPartner,
    handleImpersonate,
  }
}
